<div class="container" *ngIf="attributeSelectedLocales$ | async as attributeSelected">
    <div class="row attribute-name">
        {{ attributeSelected.name }}
    </div>
    <div class="row">
        <main>
            <emm-language-form [attributeSelected]="attributeSelected"></emm-language-form>
        </main>
        <div></div>
        <div></div>
    </div>
    <div class="row">
        <button
            class="button button-color"
            id="no-button"
            [mat-dialog-close]="false"
            mat-raised-button
            type="button"
        >
            Cancel
        </button>
        <button
            class="button button-color"
            id="yes-button"
            mat-raised-button
            type="button"
            (click)="handleSubmit()"
        >
            Save
        </button>
    </div>
</div>
<mat-icon id="close" (click)="closeDialog()">clear</mat-icon>
